import {
  APP_LOGOUT,
  ON_LOAD_SUCCESS,
  GET_LOGIN_USER_PROFILE_SUCCESS
} from './actions';

import {
  VERIFY_MFA_SUCCESS, SET_USERNAME
} from '../redux-root/actions';

const initialState = {
  authenticated: localStorage._u ? JSON.parse(localStorage._u).authenticated : false,
  init: false,
  tokenInfo: localStorage._u ? JSON.parse(localStorage._u) : null,
  userName: localStorage._n ? localStorage._n : null,
  userProfile: null
}

export function appReducer(state = initialState, action) {
  let data = action.payload;

  switch (action.type) {
    case SET_USERNAME:
      let userData = Object.assign({}, data);
      localStorage.setItem('_n', data);

      return {
        ...state,
        userName: userData
      }

    case VERIFY_MFA_SUCCESS:
      let tokenObject = Object.assign({}, data.message);

      tokenObject.authenticated = true;
      tokenObject.cogToken = action.cogToken;

      localStorage.setItem('_u', JSON.stringify(tokenObject));

      return {
        ...state,
        authenticated: true,
        tokenInfo: tokenObject
      }

    case APP_LOGOUT:
      localStorage.removeItem('_u');

      return {
        ...state,
        authenticated: false
      }

    case ON_LOAD_SUCCESS:
      return {
        ...state,
        init: true
      }

    case GET_LOGIN_USER_PROFILE_SUCCESS:
      return {
        ...state,
        userProfile: data
      }

    default:
      return state;
  }
}
